<template>
  <div class="p-3 bg-white">
    <shared-send-message
      :extensions="extensions"
      @sendMessageSuccess="sendMessageSuccess"
    ></shared-send-message>

    <div class="text-center">
      <vs-button id="sendMessageButton" class="m-2" color="primary" type="filled" @click.prevent="sendMessage">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelSendMessage">{{ $t('cancel') }}</vs-button>
    </div>

  </div>
</template>

<script>
import SharedSendMessage from '@/views/Shared/MessageManagement/SendMessage'
import { EventBus } from '@/../eventbus.js'
import Users from '@/models/User'

export default {
  name: 'Window.MessageManagement.SendMessage',
  components: {
    SharedSendMessage
  },
  data () {
    return {
      companyId: '',
      extensions: []
    }
  },
  mounted () {
    this.companyId = this.$store.getters.userInfo !== null && this.$store.getters.userInfo.company !== null ? this.$store.getters.userInfo.company.id : ''
    this.loadSettings()
  },
  methods: {
    async loadSettings () {

      const response = await Users.getExtensions({companyId: this.companyId})

      // const response = await Big.getSmalls({ id: this.consultationFormData.big_type_id })
      this.extensions = []

      for (const extension in response.data.extensions) {
        this.extensions.push({
          label: response.data.extensions[extension],
          value: extension
        })
      }

    },
    sendMessage () {
      EventBus.$emit('initSendMessage')
    },
    sendMessageSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_message_management_table')
      window.close()
    },
    cancelSendMessage () {
      this.$windowOpenerHelper.notifyOpener('reload_message_management_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
